import React, { useEffect, useState } from 'react';
import { UTILITY_OFFLINE_PAYMENT_TAB } from '../../Utils/appConstants';
import EletricityBillPayment from './eletricityBillPayment';
import WaterBillPayment from './waterBillPayment';
import GasBillPayment from './gasBillPayment';
import InsuranceBillPayment from './insuranceBillPayment';
import CommonBillPayment from '../bharatBillpayIP/commonBillPayment';
import BBPSIMW from '../bharatBillpayImWallet/commonBillPayment';
import Maintenance from './../Maintenance';
import { reactLocalStorage } from 'reactjs-localstorage';
import 'antd/dist/antd.css';
import { Tabs, Card, Modal, Button } from 'antd';
import { InfoCircleOutlined, WarningOutlined } from '@ant-design/icons';
import axios from 'axios';
import { API_URL } from '../../config';

const { TabPane } = Tabs;

// Brand colors
const PRIMARY_COLOR = '#C9262C';

function UtilityPayment2(props) {
  const [tabKey, setTabKey] = useState('1');
  const [appInfo, setAppInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [disabledModal, setDisabledModal] = useState({ visible: false, title: '', message: '' });

  useEffect(() => {
    console.log('props.location.tab -----------', props.location.tab);
    if (props.location.tab) {
      setTabKey(props.location.tab);
    }
  }, [props.location.tab]);

  // Fetch appInfo on component mount
  useEffect(() => {
    fetchAppInfo();
  }, []);

  const fetchAppInfo = async () => {
    try {
      setLoading(true);
      const response = await axios.get(API_URL + `/appinfo`);
      console.log('AppInfo fetched:', response.data);
      setAppInfo(response.data);
    } catch (err) {
      console.error("Failed to fetch app info", err);
    } finally {
      setLoading(false);
    }
  };

  const showDisabledModal = (title, message) => {
    setDisabledModal({
      visible: true,
      title: title,
      message: message
    });
  };

  // Get feature flags
  const isBbpsImWalletAvailable = appInfo?.bbpsImWalletEnabled || false;
  const isBbpsIpAvailable = appInfo?.bbpsIpEnabled !== undefined ? appInfo.bbpsIpEnabled : true;
  const isUtilityOfflineAvailable = appInfo?.utilityOfflineEnabled !== undefined ? appInfo.utilityOfflineEnabled : true;

  const onchangeTab = (index) => {
    // No need to check disabled here because only enabled tabs are shown
    reactLocalStorage.set(UTILITY_OFFLINE_PAYMENT_TAB, index, true);
    setTabKey(index);
  };

  const isUnderMaintenance = false;

  // ---- Build items only for enabled services ----
  const getEnabledItems = () => {
    const items = [];

    if (isBbpsIpAvailable) {
      items.push({
        key: '1',
        label: (
          <div className="tabtext" title="Electricity BBPS-II">
            <span>
              <img height="35" width="35" src="/images/electricity.svg" alt="Electricity" />
            </span>
            Electricity BBPS-II
          </div>
        ),
        children: <CommonBillPayment category="Electricity" />
      });
    }

    if (isBbpsImWalletAvailable) {
      items.push({
        key: '2',
        label: (
          <div className="tabtext" title="Electricity BBPS-I">
            <span>
              <img height="35" width="35" src="/images/electricity.svg" alt="Electricity" />
            </span>
            Electricity BBPS-I
          </div>
        ),
        children: <BBPSIMW category="Electricity" />
      });
    }

    if (isUtilityOfflineAvailable) {
      items.push({
        key: '3',
        label: (
          <div className="tabtext" title="Electricity Offline">
            <span>
              <img height="35" width="35" src="/images/electricity.svg" alt="Electricity" />
            </span>
            Electricity Offline
          </div>
        ),
        children: <EletricityBillPayment />
      });
    }

    return items;
  };

  const items = getEnabledItems();

  // ---- Determine a valid active tab ----
  const getValidTabKey = () => {
    // If current tabKey is not in the enabled items, switch to the first available
    const enabledKeys = items.map(item => item.key);
    if (enabledKeys.includes(tabKey)) {
      return tabKey;
    }
    // Fallback to the first enabled key
    return enabledKeys.length > 0 ? enabledKeys[0] : '1';
  };

  const activeTabKey = getValidTabKey();

  // CSS for uniform styling
  const tabStyles = `
    .utility-full-width .ant-tabs-nav {
      margin-bottom: 24px;
    }
    .utility-full-width .ant-tabs-nav .ant-tabs-tab {
      margin-right: 20px !important;
      padding: 12px 24px !important;
    }
    .utility-full-width .ant-tabs-nav .ant-tabs-tab:last-child {
      margin-right: 0 !important;
    }
    .utility-full-width .ant-tabs-tab .tabtext {
      display: flex;
      align-items: center;
      gap: 8px;
      font-weight: bold;
    }
    .utility-full-width .ant-tabs-tab .tabtext span {
      display: flex;
      align-items: center;
    }
    .utility-full-width .ant-tabs-tab .tabtext span:last-child {
      font-weight: 600;
    }
    .utility-header-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
    }
    .utility-logo-img {
      cursor: pointer;
      transition: transform 0.3s;
    }
    .utility-logo-img:hover {
      transform: scale(1.05);
    }
    .utility-card {
      border-radius: 0 !important;
      margin: 0 !important;
      box-shadow: none !important;
      border: none !important;
    }
    .utility-card .ant-card-body {
      padding: 20px !important;
    }
  `;

  return (
    <div>
      <style>{tabStyles}</style>
      {isUnderMaintenance ? (
        <Maintenance />
      ) : (
        <div className="content-wrapper pt-2" style={{ padding: 0 }}>
          <div className="content-header my-0 py-0">
            <div className="container-fluid" style={{ paddingLeft: 0, paddingRight: 0 }}>
              {/* Header with title on left and logo on right */}
              <div className="utility-header-container">
                <div>
                  <h1 className="page-title text-blue font-merriweather" style={{ margin: 0 }}>
                    Electricity <span className="text-red">BBPS</span>
                  </h1>
                </div>
                <div>
                  <img
                    className='utility-logo-img'
                    src='../images/bharat_connect.png'
                    width="100"
                    alt='Bharat Connect'
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="content" style={{ padding: 0 }}>
            <div className="container-fluid pt-2 pb-5" style={{ paddingLeft: 0, paddingRight: 0 }}>
              <div className="row" style={{ margin: 0 }}>
                <div className="col-md-12" style={{ padding: 0 }}>
                  <Card
                    className="utility-card rounded-0"
                    style={{
                      borderRadius: 0,
                      margin: 0,
                      boxShadow: 'none',
                      border: 'none'
                    }}
                    bodyStyle={{ padding: '20px' }}
                  >
                    <Tabs
                      className="recharge-tabs utility-full-width"
                      activeKey={activeTabKey}
                      defaultActiveKey={activeTabKey}
                      onChange={onchangeTab}
                      size="large"
                      tabBarGutter={20}
                      style={{ width: '100%' }}
                    >
                      {items.map(item => (
                        <TabPane tab={item.label} key={item.key}>
                          {item.children}
                        </TabPane>
                      ))}
                    </Tabs>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Disabled Service Modal – no longer needed because disabled tabs are hidden, but kept for consistency if needed elsewhere */}
      <Modal
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <InfoCircleOutlined style={{ color: '#faad14', fontSize: '20px' }} />
            <span>{disabledModal.title}</span>
          </div>
        }
        open={disabledModal.visible}
        onOk={() => setDisabledModal({ visible: false, title: '', message: '' })}
        onCancel={() => setDisabledModal({ visible: false, title: '', message: '' })}
        okText="Got It"
        cancelButtonProps={{ style: { display: 'none' } }}
        centered
      >
        <div style={{ padding: '8px 0' }}>
          <p style={{ fontSize: '14px', color: '#4a5568', margin: 0 }}>
            {disabledModal.message}
          </p>
        </div>
      </Modal>
    </div>
  );
}

export default UtilityPayment2;